import { render, staticRenderFns } from "./showMessage.vue?vue&type=template&id=4cd48d60&scoped=true&"
import script from "./showMessage.vue?vue&type=script&lang=js&"
export * from "./showMessage.vue?vue&type=script&lang=js&"
import style0 from "./showMessage.vue?vue&type=style&index=0&id=4cd48d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd48d60",
  null
  
)

export default component.exports